import { render, staticRenderFns } from "./DeprecatedInput.vue?vue&type=template&id=0f4ffb6c"
import script from "./DeprecatedInput.vue?vue&type=script&lang=js"
export * from "./DeprecatedInput.vue?vue&type=script&lang=js"
import style0 from "@cognitoforms/styles/app/inputs.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c5e5751f5b0cd1e9b9bbc1ebf85fd207/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports